import { jsxs as d, jsx as m } from "react/jsx-runtime";
import { supportedAttributes as b } from "./supportedAttributes.js";
import e from "./nutritionalattributehighlights.module.js";
const g = ({
  name: i,
  label: s,
  hideLabel: n
}) => {
  const o = b[i];
  if (!o)
    return null;
  const { symbol: c, color: r, textColor: t, borderColor: l } = o;
  return /* @__PURE__ */ d("div", { className: e.highlightContainer, children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: e.symbol,
        style: {
          ...r && {
            backgroundColor: r
          },
          ...l && {
            borderColor: l,
            borderWidth: 1,
            borderStyle: "solid"
          },
          ...t && { color: t }
        },
        children: c
      }
    ),
    n ? null : s
  ] });
};
export {
  g as AttributeHighlight
};
